<template>
  <div id="app">
    <nav class="navbar navbar-expand-lg navbar-dark" v-if="isLoggedIn()">
      <a class="navbar-brand" href="/">
        <img src="https://vtms.blob.core.windows.net/public/ntsa/images/navbar-brand-img.png" alt="NTSA Branding"  />
      </a>

      <div class="collapse navbar-collapse">        
        <ul class="navbar-nav ml-auto">
          <li>
            <button class="btn" @click="confirmLogout()" style="padding-top: 10px; padding-bottom: 10px; color: white;">
              <span class="mdi mdi-logout"></span> &nbsp; Logout {{ userInfo().name }}
            </button>
          </li>
        </ul> 
      </div>
    </nav>

    <!-- Breadcrumbs -->
    <nav aria-label="breadcrumb" v-if="isLoggedIn()">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">VTMS KENYA</li>
        <li v-for="(breadcrumb, idx) in breadcrumbParts" :key="idx" class="ml-1">
          &nbsp;/&nbsp; {{ breadcrumb.toUpperCase() }}
        </li>
      </ol>
    </nav>
    <!-- /Breadcrumbs -->

    <div class="container-fluid">
      <div class="row">
        <!-- Side nav -->
        <div class="hidden-xs col-sm-2 left-nav-container" v-if="isLoggedIn()">
          <div class="list-group left-nav">
              <router-link :to="{ name: 'dashboard' }" :class="getNavActiveClass('dashboard')" class="list-group-item list-group-item-action">
                DASHBOARD
              </router-link>
              <router-link :to="{ name: 'search-tests' }" :class="getNavActiveClass('search')" class="list-group-item list-group-item-action">
                VEHICLE SEARCH
              </router-link>
              <router-link :to="{ name: 'station-index' }" :class="getNavActiveClass('station')" class="list-group-item list-group-item-action">
                STATION MANAGEMENT
              </router-link>
              <a href="" class="list-group-item list-group-item-action disabled">OWNER LOOKUP</a>
              <a href="" class="list-group-item list-group-item-action disabled">PENDING TESTS</a>
              <!-- <a href="" class="list-group-item list-group-item-action disabled">STATION MONITOR</a>
              <a href="" class="list-group-item list-group-item-action disabled">STATION SUPPORT</a> -->
              <a href="" class="list-group-item list-group-item-action disabled">STATISTICS</a>
              <a href="" class="list-group-item list-group-item-action disabled">BULLETINS</a>
              <a href="" class="list-group-item list-group-item-action disabled">DOCUMENTS</a>
              <a href="" class="list-group-item list-group-item-action disabled">REMOTE SUPPORT</a>
              <a href="" class="list-group-item list-group-item-action">USER ADMINISTRATION</a>
          </div>
        </div>
        <!-- /Side nav -->

        <div class="col-sm-10">
          <router-view/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        routeName: 'dashboard',
        breadcrumbParts: [ 'Dashboard' ]
      }
    },
    watch: {
      '$route': function(route) {
        this.routeName = route.name
        console.log(route)
        this.breadcrumbParts =  route.meta && route.meta.breadcrumbs ? route.meta.breadcrumbs : []
      }
    },
    methods: {
      isLoggedIn() {
        return this.$authService.isLoggedIn()
      },
      userInfo() {
        return this.$authService.getUserInfo() ||  { }
      },
      confirmLogout() {
        this.$bvModal
            .msgBoxConfirm(`Are you sure you wish to log out from VTMS Kenya?`)
            .then(value => {
                if (value) this.$authService.logout()
            })
      },
      getNavActiveClass(routePrefix) {
        return this.routeName && this.routeName.startsWith(routePrefix) ? 'active' : ''
      }
    }
  }
</script>